import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDocumentLayoutItem } from '../layout-item';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { ITemplatePlaceHolderControlContent } from '@fi-app/template/template';
import { IMediaBankFileReference } from '@fi-shared/media-bank';

@Component({
    selector: 'fi-document-layout-item-image',
    templateUrl: './layout-item-image.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./layout-item-image.component.scss'],
    standalone: false,
})
export class FiDocumentLayoutItemImageComponent extends FiDocumentLayoutItem implements OnInit {
    constructor(templateLayoutLanguageService: TemplateLayoutLanguageService) {
        super(templateLayoutLanguageService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    onContentFileChanged($event: IMediaBankFileReference, content: ITemplatePlaceHolderControlContent, column: number) {
        this.templateLayoutHelper.setTemplatePlaceHolderImageContent(content, column, $event);
    }
}
